import { render, staticRenderFns } from "./NotificationCodeList.vue?vue&type=template&id=25fa929f&scoped=true&"
import script from "./NotificationCodeList.vue?vue&type=script&lang=js&"
export * from "./NotificationCodeList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCodeList.vue?vue&type=style&index=0&id=25fa929f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fa929f",
  null
  
)

export default component.exports